import React, { useRef, useEffect, useState } from "react";
import * as tf from "@tensorflow/tfjs";

const DoorFrameDetector = ({ imageSrc }) => {
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const [model, setModel] = useState(null);

  // 1. Load the model on mount
  useEffect(() => {
    const loadModel = async () => {
      // In a real app, you'd use tf.loadLayersModel('url-to-your-model')
      // For this example, we'll define the architecture we discussed
      const m = tf.sequential();
      m.add(
        tf.layers.conv2d({
          inputShape: [256, 256, 3],
          kernelSize: 3,
          filters: 32,
          activation: "relu",
        })
      );
      m.add(tf.layers.flatten());
      m.add(tf.layers.dense({ units: 8, activation: "linear" })); // 8 outputs for 4 points (x,y)

      // Note: You would need to load your trained weights here!
      setModel(m);
    };
    loadModel();
  }, []);

  const detectLines = async () => {
    if (!model || !imageRef.current) return;

    // 2. Pre-process the image for TensorFlow
    const tensor = tf.browser
      .fromPixels(imageRef.current)
      .resizeNearestNeighbor([256, 256])
      .toFloat()
      .div(tf.scalar(255))
      .expandDims();

    // 3. Run Inference
    const prediction = await model.predict(tensor);
    const coords = await prediction.data(); // [x1, y1, x2, y2, x3, y3, x4, y4]

    drawLines(coords);
  };

  // 4. Draw the Parallel Lines using the Canvas API
  const drawLines = (coords) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { width, height } = canvas;

    ctx.clearRect(0, 0, width, height);
    ctx.strokeStyle = "#00FF00"; // Neon green for visibility
    ctx.lineWidth = 4;

    // Line 1 (Left side of door)
    ctx.beginPath();
    ctx.moveTo(coords[0] * width, coords[1] * height);
    ctx.lineTo(coords[2] * width, coords[3] * height);
    ctx.stroke();

    // Line 2 (Right side of door)
    ctx.beginPath();
    ctx.moveTo(coords[4] * width, coords[5] * height);
    ctx.lineTo(coords[6] * width, coords[7] * height);
    ctx.stroke();
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        ref={imageRef}
        src={imageSrc}
        alt="Door"
        onLoad={detectLines}
        style={{ width: "500px", height: "auto" }}
      />
      <canvas
        ref={canvasRef}
        width={500}
        height={667} // Adjust based on your image aspect ratio
        style={{ position: "absolute", top: 0, left: 0 }}
      />
      <button
        onClick={detectLines}
        style={{ display: "block", marginTop: "10px" }}
      >
        Refresh Detection
      </button>
    </div>
  );
};

export default DoorFrameDetector;
